@if (transactionList.length === 0) {
  <div>
    <em>{{ getOption('noItemsMessage') }}</em>
  </div>
}

@if (transactionList.length > 0) {
  <div >
    <div>
      @switch (getOption('displayFormat')) {
        @case ('table-3-col') {
          <table class="xct-table xct-format-{{ getOption('displayFormat') }} table table-hover">
            <thead>
              <tr>
                <th class="xct-col-timestamp">Completed</th>
                <th class="xct-col-action"></th>
                <th class="xct-col-amount">Amount</th>
              </tr>
            </thead>
            <tbody>
              @for (transaction of transactionList; track transactionTrackBy(i, transaction); let i = $index) {
                <tr [ngClass]="{'xct-inflow': transaction.isAccountInflow(), 'xct-outflow': transaction.isAccountOutflow() }"  >
                  <td class="xct-col-timestamp">
                    <div class="xct-timestamp-month">{{ transaction.timestamp | date: 'MMM' }}</div>
                    <div class="xct-timestamp-day">{{ transaction.timestamp | date: 'dd' }}</div>
                  </td>
                  <td class="xct-col-action">
                    @if (transaction.url) {
                      <a (click)="goToUrl(transaction)"
                        [title]="transaction.title"
                      >{{ transaction.title }}</a>
                    }
                    @if (!transaction.url) {
                      <span>{{ transaction.title }}</span>
                    }
                    @if (optionsForSingle.isDebug) {
                      <div class="xct-debug-json">{{ transaction | json }}</div>
                    }
                  </td>
                  <td class="xct-col-amount">
                    {{ transaction.token_cents | xsactCurrency:transaction.token_class:'hundredth_c' }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
        @default {
          @for (transaction of transactionList; track transactionTrackBy(i, transaction); let i = $index) {
            <app-elements-transaction-single [transaction]="transaction" [options]="optionsForSingle" [counter]="i + 1" [totalCount]="transactionList.length"></app-elements-transaction-single>
          }
        }
      }
    </div>
  </div>
}
